import Navbar from "@/components/Navbar";
import { web } from "@/config/System";
import useDataPendaftaran from "@/hooks/useDataPendaftaran";
import { useUser } from "@/hooks/useUser";
// import api from "@/lib/axios";
import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

// type PasswordResetState = {
//   password: string;
//   password_confirmation: string;
// };

// const resetPassword = async (form: PasswordResetState) => {
//   const response = await api.patch("/siswa/force-reset-password", form);
//   return response.data;
// };

export default function SiswaLayout() {
  const { user, isPending } = useUser();
  // const navigate = useNavigate()
  const { isFetched, dataPendaftaran } = useDataPendaftaran();

  const userRoles = user?.jenis_user || [];
  const siswa = userRoles.includes("siswa");

  // const [form, setForm] = useState<PasswordResetState>({
  //   password: "",
  //   password_confirmation: "",
  // });
  // const [showModal, setShowModal] = useState(
  //   Boolean(user?.must_reset_password) || false
  // );

  // const { mutate, isPending: isPendingResetPassword } = useMutation({
  //   mutationFn: resetPassword,
  //   onSuccess: (data) => {
  //     setShowModal(false);
  //     toast.success(data?.message || "Success.");
  //   },
  //   onError: (error: AxiosError) => {
  //     const err = error as AxiosError<{ message?: string }>;
  //     toast.error(
  //       err?.response?.data?.message || "An unexpected error occurred."
  //     );
  //   },
  // });

  // const handleResetPassword = (event: React.FormEvent<HTMLFormElement>) => {
  //   event.preventDefault();
  //   mutate(form);
  // };

  // useEffect(() => {
  //   if (user?.must_reset_password) setShowModal(true);
  // }, [user]);

  useEffect(() => {
    // if (isFetched && !dataPendaftaran) navigate("/dashboard");
    if (isFetched && !dataPendaftaran) return;
  }, [isFetched, dataPendaftaran]);

  if (isPending)
    return (
      <div className="h-screen flex justify-center items-center">
        <div>
          <img
            src={web.logoApp}
            alt="e-Ganesha"
            width={100}
            className="animate-pulse"
          />
        </div>
      </div>
    );

  if (!siswa) return <Navigate to={"/"} />;

  return (
    <div translate="no">
      <Navbar />
      <div className="my-10 container mx-auto lg:px-20 px-4">
        <Outlet />
      </div>

      {/* {user?.must_reset_password ? (
        <div>
          <Modal
            show={showModal}
            closeable={false}
            onClose={() => !user?.must_reset_password && setShowModal(false)}
          >
            <FormHeader
              icon={<RiLockPasswordFill />}
              title="Ganti Password Default"
              description="Anda diminta untuk mengganti password default untuk meningkatkan keamanan akun. Harap masukkan password baru dan konfirmasikan."
            />

            <form
              onSubmit={handleResetPassword}
              className="flex flex-col gap-y-3"
            >
              <div>
                <Label>Password Baru</Label>
                <Input
                  type="password"
                  placeholder="Ketik password baru.."
                  value={form.password}
                  onChange={(event) =>
                    setForm((prev) => ({
                      ...prev,
                      password: event.target.value,
                    }))
                  }
                />
              </div>
              <div>
                <Label>Konfirmasi Password Baru</Label>
                <Input
                  type="password"
                  placeholder="Ketik ulang password baru.."
                  value={form.password_confirmation}
                  onChange={(event) =>
                    setForm((prev) => ({
                      ...prev,
                      password_confirmation: event.target.value,
                    }))
                  }
                />
              </div>
              <Button
                className="mt-3 w-fit flex items-center gap-3"
                disabled={isPendingResetPassword}
              >
                {isPendingResetPassword ? (
                  <>
                    <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                    Processing...
                  </>
                ) : (
                  "Simpan"
                )}
              </Button>
            </form>
          </Modal>
        </div>
      ) : null} */}
    </div>
  );
}
